import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { ERROR_CODES } from 'src/app/shared/constants/error-codes';
import {
  NotFoundError,
  OperationFailedError,
} from 'src/app/shared/errors/errors';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { IDevice } from '../add-lock/lock-management-interfaces';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DeviceManagementService {
  private url = environment.graphqlUrl;

  constructor(
    private http: HttpClient,
    private stateManagementService: StateManagementService,
    private translate: TranslateService
  ) {}

  /**
   * @description this method calls API to AddPartnerDevice
   * @param { string } deviceName
   * @param { string } macAddress
   * @param { string } accessPointId
   * @param { string } deviceType
   * @returns { Observable<any> }
   */
  addPartnerDevice(
    deviceName: string,
    macAddress: string,
    accessPointId: string,
    deviceType: string
  ): Observable<any> {
    return this.http
      .post<any>(`${this.url}`, {
        query: `mutation AddPartnerDevice ($deviceName: String!,$macAddress: String!, $deviceType: String! $accessPointId: String!) { addPartnerDevice (deviceName: $deviceName,macAddress: $macAddress, deviceType: $deviceType, accessPointId: $accessPointId) {    deviceId    } }`,
        variables: {
          deviceName: deviceName,
          macAddress: macAddress,
          accessPointId: accessPointId,
          deviceType: deviceType,
        },
      })
      .pipe(
        map((res) => {
          try {
            if (res?.data && res?.data?.addPartnerDevice?.deviceId) {
              const device: IDevice = res.data.addPartnerDevice;
              device.deviceName = deviceName;
              device.macAddress = macAddress;
              device.accessPointId = accessPointId;
              device.deviceType = deviceType;
              const devices =
                this.stateManagementService.getParttnerDeviceList();
              devices?.push(device);
              this.stateManagementService.updatePartnerDeviceList(devices);
              return res?.data?.addPartnerDevice;
            } else if (res?.errors?.length > 0) {
              let errorList = res?.errors.map((error: any) => error.message)[0];
              if (
                errorList.includes(ERROR_CODES.PARTNER_DEVICE_ALREADY_EXISTS)
              ) {
                throw new Error(
                  this.translate.instant('PARTNER_DEVICE_ALREADY_EXISTS')
                );
              } else if (errorList.includes(ERROR_CODES.DEVICEID)) {
                throw new Error(
                  this.translate.instant('YOU_MUST_ENTER_SERIAL_NUMBER')
                );
              } else if (errorList.includes(ERROR_CODES.DEVICENAME)) {
                throw new Error(
                  this.translate.instant('YOU_MUST_ENTER_LOCK_NAME')
                );
              } else if (
                errorList.includes(ERROR_CODES.ACCESS_POINT_ALREADY_EXISTS)
              ) {
                throw new Error(
                  this.translate.instant('ACCESS_POINT_NAME_ALREADY_EXISTS')
                );
              }
              throw new Error(
                this.translate.instant('FAILED_TO_ADD_DEVICE_SERVER_ERROR')
              );
            }
          } catch (error: any) {
            throw new Error(error?.message);
          }
        })
      );
  }
}
